// extracted by mini-css-extract-plugin
module.exports = {"tinyWidget":"TinyWidget_tinyWidget__1NvaY","disabled":"TinyWidget_disabled__1kyd4"};